import { render, staticRenderFns } from "./Step5DetailedEdit.vue?vue&type=template&id=67f5fe81&scoped=true"
import script from "./Step5DetailedEdit.vue?vue&type=script&lang=js"
export * from "./Step5DetailedEdit.vue?vue&type=script&lang=js"
import style0 from "./Step5DetailedEdit.vue?vue&type=style&index=0&id=67f5fe81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5fe81",
  null
  
)

export default component.exports